import { cacheUtility } from "@utils/cacheUtils";
import config from '../../../../config/config'
import dayjs from "dayjs";
import { dateFormate } from "@constants/index";

const BASE_URL = `${config.baseURL}/api/v1`;
const NEW_BASE_URL = `${config.baseURL}/rest-api/v1`;

export const clearRecentAncData = (pregnancyId:any, ancNo:number) => {
    cacheUtility.remove(`${NEW_BASE_URL}/services/pregnancies/${pregnancyId}/${ancNo}/subcategories`);
}

export const clearRecentPncData = (pregnancyId:any, pncNo:number) => {
    const url = `${BASE_URL}/serviceSubCategoryListByPregnancyAndPNC`;
    cacheUtility.remove(`${url}/${pregnancyId}/${pncNo}`);
}

export const clearRecentPncChildData = (childId:any, hbncNo:number) => {
    const url = `${BASE_URL}/ServiceSubcategoryListByChildBeneficiaryHbncNo`;
    cacheUtility.remove(`${url}/${childId}/${hbncNo}`);
}

export const formatName = (firstName: string, lastName: string) => {
    return `${firstName ? firstName : ''} ${lastName ? lastName : ''}`.trim();
};

export const onSameDay = (date: any) => {
    return dayjs(date).format(dateFormate.dd_mm_yyyy) === dayjs(new Date()).format(dateFormate.dd_mm_yyyy);
}